/* sm-kross-vel.js - the memorial cross engine (minningarskilti á kross) for the one page kit (samraeming L3, 2026-09-29).
   Verbatim move out of assets/sm-krossaskilti.js e78d02ba (the old page keeps that file, untouched): variant model,
   state, dates, the Shopify variant lookup, the plate preview (.kr-plate, styled by sm-krossaskilti.css), the photo
   and the whole production file code (SMFram). The old page's own steps, events, add to cart and bar are left out:
   the kit owns them. Built by samraeming/L3-krossar/src/bua_kross_vel.py; the adapter is assets/sm-vs-kross.js.
   CU 19.10.2026: the production file no longer depends on the browser. Text positions, line breaks, baselines and the
   name come from the fonts (SMFram font files, Tinos as sm-letur-tinos-400.json) and the CSS rules (framLikan), the
   owner's symbols from fixed outlines (sm-kr-takn-<id>.json); same file in Chrome, Safari and Firefox. The old page-
   measured path stays as the fallback (framSpec, when a font or glyph is missing).

   window.SMKrossVel.ny(root, vid) -> engine for one page. root = the element that holds .pdp-kr .kr-canvas .kr-plate
   (the kit drawing box); its data-start-subject / data-start-material pick the start, as on the old page.
   vid = { breytt() } is told after the photo finished loading. */
(function () {
  "use strict";
  if (window.SMKrossVel) return;
  function ny(root, vid) {
  if (!root) return null;
  // Absolute asset base: CSS url() inside inline styles / mask must never be relative
  var ASSET = new URL(root.getAttribute("data-asset-url") || "assets/", document.baseURI).href;
  var MONTHS = ["janúar","febrúar","mars","apríl","maí","júní","júlí","ágúst","september","október","nóvember","desember"];

  // ─── Variant model ─────────────────────────────────────────────────────────
  var SIZES2 = [
    { id: "S", name: "Lítið", dim: "20 × 6 cm", w: 440, h: 132, match: ["20"] },
    { id: "L", name: "Stórt", dim: "30 × 7,5 cm", w: 560, h: 140, match: ["30"] }
  ];
  var SIZES1 = [SIZES2[0]];
  var NONE = { id: "none", name: "Ekkert tákn" };
  var LEFT_PERSON = [{ id: "kross", name: "Kross" }, { id: "hjartakross", name: "Hjartakross" }, { id: "utlina", name: "Útlínukross" }, { id: "rammi", name: "Rammakross" }, { id: "tru-von", name: "Trú, von, kærleikur" }, NONE];
  var LEFT_PET = [{ id: "kross", name: "Kross" }, { id: "hjartakross", name: "Hjartakross" }, { id: "utlina", name: "Útlínukross" }, { id: "rammi", name: "Rammakross" }, NONE];
  var RIGHT_PERSON = [{ id: "dufa", name: "Dúfa" }, { id: "ros-stilk", name: "Rós á stilk" }, { id: "bangsi", name: "Bangsi" }, { id: "lifsins-tre", name: "Lífsins tré" }, { id: "engill", name: "Engill" }, { id: "ankeri", name: "Ankeri" }, NONE];
  // id = skráarheitið sm-kr-<id>.svg; "loppuhjarta" (2026-09-27, eigin teikning) fær nýtt heiti því myndir þemans hafa ekkert ?v= og sitja ár í skyndiminni.
  var RIGHT_PET = [{ id: "loppa", name: "Loppa" }, { id: "loppuhjarta", name: "Loppa með hjarta" }, NONE];
  var PHOTO_PERSON = { id: "photo", name: "Ljósmynd", upcharge: 4000 };
  var PHOTO_PET = { id: "eigin-mynd", name: "Eigin mynd", upcharge: 1990 };
  // photoSide = hvorum megin varan sjálf hefur myndina. Manneskja ál: "Mynd hægra megin: Ljósmynd (+4.000kr.)".
  // Gæludýr ál: "Kross vinstra megin: Eigin mynd (+1.990kr.)", og loppan helst hægra megin. photoSideFromShop() les þetta úr vörunni ef hún er til.
  var VARIANTS = {
    "person-al":    { label: "Minningarskilti á kross - ál", basePrice: 8490, colors: ["black"], sizes: SIZES2, left: LEFT_PERSON, right: RIGHT_PERSON, photo: PHOTO_PERSON, photoSide: "right" },
    "person-akryl": { label: "Minningarskilti á kross - akrýl", basePrice: 10990, colors: ["black", "white"], sizes: SIZES2, left: LEFT_PERSON, right: RIGHT_PERSON, photo: null },
    "pet-al":       { label: "Skilti á kross fyrir gæludýr - ál", basePrice: 8490, colors: ["black"], sizes: SIZES1, left: LEFT_PET, right: RIGHT_PET, photo: PHOTO_PET, photoSide: "left" },
    "pet-akryl":    { label: "Skilti á kross fyrir gæludýr - akrýl", basePrice: 8490, colors: ["white", "black"], sizes: SIZES1, left: LEFT_PET, right: RIGHT_PET, photo: null }
  };
  var COLOR_NAME = { black: "Svart", white: "Hvítt" };
  // Orðalag eigandans, óbreytt úr Easify á lifandi síðunni ("Texti efst:" / "Texti neðst:"). "Enginn texti" og "Skrifa sjálf/ur…" bætast við í fillSelect.
  var NO_TEXT = "Enginn texti";
  var TOPS = {
    person: ["Hér hvílir", "Í ástkærri minningu", "Í minningu okkar allra", "Við söknum þín"],
    pet: ["Hér hvílir", "Í ástkærri minningu", "Elsku vinur okkar", "Trúfasti félagi okkar", "Besti vinur", "Við söknum þín"]
  };
  var BOTTOMS = {
    person: ["Blessuð sé minning þín", "Minning þín lifir", "Ævinlega í hjörtum okkar", "Þín er sárt saknað", "Hvíldu í friði"],
    pet: ["Takk fyrir allt, vinur minn", "Alltaf í hjarta okkar", "Minningin um þig lifir", "Þú varst fjölskylda", "Þakka þér fyrir samveruna", "Þú færðir okkur svo mikla gleði"]
  };
  var MB = 1048576, PHOTO_MAX = 19 * MB; // Shopify hafnar skrá frá 20 MiB (413); sama hámark og sm-skra.js
  var SAMPLE_NAME = { person: "Anna María Jónsdóttir", pet: "Snati" };
  var SAMPLE_DATES = { person: "1. janúar 1945 - 8. febrúar 2025", pet: "12. maí 2010 - 3. júní 2024" };
  var EFNI = [{ mat: "al", color: "black", name: "Ál · Svart", sub: "Veðurþolnast" }, { mat: "akryl", color: "black", name: "Akrýl · Svart", sub: "Matt, létt" }, { mat: "akryl", color: "white", name: "Akrýl · Hvítt", sub: "Ljóst og bjart" }];

  // ─── Shopify data (optional) ───────────────────────────────────────────────
  var GOGN = {};
  try { var g = root.querySelector("[data-kr-gogn]"); if (g) GOGN = JSON.parse(g.textContent) || {}; } catch (e) { GOGN = {}; }
  function norm(s) { return (s || "").toString().toLowerCase().replace(/\s+/g, " ").trim(); }
  function squash(s) { return norm(s).replace(/[\s-]+/g, ""); }
  function findShopifyVariant(key, color, size, wantPhoto, symbols) {
    var p = GOGN[key]; if (!p || !p.variants || !p.variants.length) return null;
    var wantColor = color === "white" ? ["hvít", "white"] : ["svart", "black"];
    var best = null, bestScore = -1;
    p.variants.forEach(function (v) {
      var opts = v.o.map(norm).join(" | "), s = 0;
      if (wantColor.some(function (w) { return opts.indexOf(w) > -1; })) s += 4;
      if (size.match.some(function (w) { return opts.indexOf(w) > -1; })) s += 2;
      if ((/mynd|ljósmynd|photo/.test(opts)) === wantPhoto) s += 1;
      if (v.available !== false) s += 0.5;
      var flat = squash(v.o.join("|"));
      (symbols || []).forEach(function (n) { if (n && flat.indexOf(squash(n)) > -1) s += 0.2; });
      if (s > bestScore) { bestScore = s; best = v; }
    });
    return best;
  }
  // Hvorum megin er myndin í Shopify-vörunni? Finnur valkostinn sem hefur mynd-gildi ("Ljósmynd (+4.000kr.)",
  // "Eigin mynd (+1.990kr.)") og les "vinstra"/"hægra" úr heiti hans ("Kross vinstra megin:", "Mynd hægra megin:").
  function photoSideFromShop(key) {
    var p = GOGN[key]; if (!p || !p.variants || !p.options) return "";
    for (var i = 0; i < p.options.length; i++) {
      var hasPhoto = p.variants.some(function (v) { return /mynd|photo/.test(norm((v.o || [])[i])); });
      if (!hasPhoto) continue;
      var n = norm(p.options[i] && p.options[i].name ? p.options[i].name : p.options[i]);
      if (n.indexOf("vinstra") > -1 || n.indexOf("left") > -1) return "left";
      if (n.indexOf("hægra") > -1 || n.indexOf("right") > -1) return "right";
    }
    return "";
  }
  function kr(n) { var s = Math.round(n).toString(), out = ""; while (s.length > 3) { out = "." + s.slice(-3) + out; s = s.slice(0, -3); } return s + out + " kr."; }
  function esc(s) { return (s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  // ─── State ─────────────────────────────────────────────────────────────────
  var st = {
    subject: root.getAttribute("data-start-subject") || "person",
    material: root.getAttribute("data-start-material") || "al",
    color: "black", size: "L", left: "kross", right: "dufa", photoOn: false,
    name: "", birth: { d: 0, m: 0, y: 0 }, death: { d: 0, m: 0, y: 0 },
    top: TOPS.person[0], bottom: BOTTOMS.person[0], topCustom: false, bottomCustom: false, topText: "", bottomText: "",
    notes: "", photoName: "", photoDataUrl: "", confirmed: false
  };
  var photoFile = null, photoErr = ""; // skráin sjálf (fer í körfuna) og villa við val hennar
  var q = new URLSearchParams(location.search);
  if (q.get("utgafa") === "pet") st.subject = "pet";
  if (q.get("efni") === "akryl") st.material = "akryl";
  // ?variant= (t.d. úr litapunkti á vörukorti eða körfutengli) byrjar í þeim lit
  var qv = q.get("variant");
  if (qv) Object.keys(GOGN).forEach(function (k) {
    var p = GOGN[k]; if (!p || !p.variants) return;
    p.variants.forEach(function (v) {
      if (String(v.id) !== qv) return;
      var o = norm((v.o || []).join(" "));
      if (o.indexOf("hvít") > -1) st.color = "white"; else if (o.indexOf("svart") > -1) st.color = "black";
    });
  });
  function key() { return st.subject + "-" + st.material; }
  function V() { return VARIANTS[key()]; }
  function by(list, id) { return list.filter(function (s) { return s.id === id; })[0] || list[0]; }
  function sizeObj() { return by(V().sizes, st.size); }
  // Hlið myndarinnar: fyrst eins og Shopify-varan segir, annars úr VARIANTS. Akrýl hefur enga mynd, svo þar gildir
  // hlið ál-vörunnar sama viðfangs (þangað fer "Ljósmynd er í boði á álskiltum").
  function photoSide() {
    var k = V().photo ? key() : st.subject + "-al";
    return photoSideFromShop(k) || (VARIANTS[k] && VARIANTS[k].photoSide) || "right";
  }
  function photoActive() { return !!(st.photoOn && V().photo); }
  function photoLeft() { return photoActive() && photoSide() === "left"; }
  function photoRight() { return photoActive() && photoSide() === "right"; }
  function leftObj() { return photoLeft() ? V().photo : by(V().left, st.left); }
  function rightObj() { return photoRight() ? V().photo : by(V().right, st.right); }
  // Dagsetningar: ár er skylda, dagur og mánuður valfrjáls (á lifandi síðunni var þetta frjáls texti).
  // Á skiltið og í pöntunina fer nákvæmlega það sem var valið: "1. janúar 1956", "janúar 1956" eða "1956".
  function daysIn(m, y) { return new Date(y || 2000, m, 0).getDate(); }
  function dateEmpty(d) { return !d.d && !d.m && !d.y; }
  function dateProblem(d) {
    if (dateEmpty(d)) return "";
    if (!d.y) return "veldu ár";
    if (d.d && !d.m) return "veldu mánuð líka, eða taktu daginn út";
    if (d.d && d.d > daysIn(d.m, d.y)) return d.d + ". " + MONTHS[d.m - 1] + " " + d.y + " er ekki til";
    return "";
  }
  function dateOk(d) { return !dateEmpty(d) && !dateProblem(d); }
  function dateFuture(d) {
    if (!dateOk(d)) return false;
    var n = new Date(), Y = n.getFullYear(), M = n.getMonth() + 1, D = n.getDate();
    return d.y > Y || (d.y === Y && !!d.m && (d.m > M || (d.m === M && !!d.d && d.d > D)));
  }
  function datePartial(d) { return !dateEmpty(d) && !dateOk(d); }
  function fmtDate(d) { return dateOk(d) ? (d.d ? d.d + ". " : "") + (d.m ? MONTHS[d.m - 1] + " " : "") + d.y : ""; }
  // fæðing má ekki vera á eftir andláti; aðeins borið saman það sem bæði hafa
  function datesInOrder() {
    var b = st.birth, x = st.death; if (!dateOk(b) || !dateOk(x)) return true;
    if (b.y !== x.y) return b.y < x.y;
    if (!b.m || !x.m || b.m !== x.m) return !b.m || !x.m || b.m < x.m;
    return !b.d || !x.d || b.d <= x.d;
  }
  // ─── Stóra álskiltið og frjáls hamur (eigandi 24.10, krossar-stort-al/PLAN.md A2) ─────────────────
  // Stórt ál (30 x 7,5 cm): allur texti í dálki sem er mest 120 mm (224 dílar), nafnið ein lína sem minnkar án lágmarks,
  // aðrar línur brotna í dálkinum og minnka ef eitt orð er samt of breitt, dálkurinn minnkar allur (sama hlutfall) ef
  // hann er hærri en platan, 4 mm göt (miðjur óbreyttar), tvær keyrslur (KEYRSLA-2 = hægra merki og hægra gat).
  // Frjáls hamur (aðeins verkstæðisforritið, vefurinn notar hann aldrei): st.linur = [{ teg: "nafn"|"dags"|"rod", t }]
  // teiknast í röð í stað efst/nafn/dagsetninga/neðst, textinn nákvæmlega eins og hann kemur, sömu reglur, á öllum stærðum.
  // Annars er allt eins og áður (litla álskiltið, akrýl og gæludýr gefa sömu skrá).
  var STORT_AL_TEXTI_MM = 120, GAT_MM = 4, KR_GAT_PX = 11, KR_GAT_BRUN = 20, KR_MIN_PX = 1;
  var KEYRSLUR = "1 svart: kross, texti og vinstra gat | 2 blátt: merki og hægra gat";
  function stortAl() { return st.material === "al" && st.size === "L"; }
  function linurFrjals() {
    if (!st.linur || typeof st.linur.length !== "number") return [];
    return Array.prototype.filter.call(st.linur, function (l) { return l && /\S/.test(String(l.t == null ? "" : l.t)); }).map(function (l) {
      return { teg: l.teg === "nafn" || l.teg === "dags" ? l.teg : "rod", t: String(l.t) };
    });
  }
  function frjals() { return linurFrjals().length > 0; }
  function nyjarReglur() { return stortAl() || frjals(); }
  function plotuMm(s) { return parseFloat(s.dim) * 10; }
  // Breidd textadálksins í dílum plötunnar: táknhólfin alltaf frátekin; stórt ál mest 120 mm
  function textaBreidd(s) {
    var a = s.w - 76 - 2 * Math.min(s.w * 0.18, 100) - 44;
    return stortAl() ? Math.min(a, STORT_AL_TEXTI_MM * s.w / plotuMm(s)) : a;
  }
  function kvarda(v) { return Math.round(v * 100) / 100; }
  function topText() { return st.topCustom ? st.topText.trim() : st.top; }
  function bottomText() { return st.bottomCustom ? st.bottomText.trim() : st.bottom; }
  function nameOk() { return frjals() || st.name.trim().length >= 2; }
  // 18.10 (eigandi): á gæludýraskilti eru dagsetningar valfrjálsar. Báðar tómar = engin dagsetningalína á skiltinu
  // (nafnið miðjast); annars gilda sömu reglur og á skilti fyrir manneskju (báðar, ártal eitt og sér leyft). Manneskja óbreytt.
  function datesNone() { return dateEmpty(st.birth) && dateEmpty(st.death); }
  function datesOptional() { return st.subject === "pet"; }
  function datesOk() { return frjals() || (datesOptional() && datesNone()) || (dateOk(st.birth) && dateOk(st.death) && datesInOrder()); }
  // engin dagsetningalína: gæludýr, báðar tómar og nafn skrifað (án nafns sýnir platan sýnidæmið með sýnidagsetningum)
  function datesHidden() { return datesOptional() && datesNone() && !!st.name.trim(); }
  // "Skrifa sjálf/ur…" valið en ekkert skrifað: má ekki detta út þegjandi
  function customOk() { return frjals() || (!(st.topCustom && !topText()) && !(st.bottomCustom && !bottomText())); }
  function photoOk() { return !photoActive() || !!photoFile; }
  function canOrder() { return nameOk() && datesOk() && customOk() && photoOk() && st.confirmed; }
  function missingList() {
    var m = [];
    if (!nameOk()) m.push("nafn");
    if (!datesOk()) m.push("dagsetningar");
    if (st.topCustom && !topText()) m.push("eigin texti efst");
    if (st.bottomCustom && !bottomText()) m.push("eigin texti neðst");
    if (!photoOk()) m.push("ljósmynd");
    return m;
  }
  function andJoin(a) { return a.length < 2 ? a.join("") : a.slice(0, -1).join(", ") + " og " + a[a.length - 1]; }
  function validate() {
    var v = V();
    if (v.colors.indexOf(st.color) < 0) st.color = v.colors[0];
    if (!v.sizes.some(function (s) { return s.id === st.size; })) st.size = v.sizes[0].id;
    if (!v.left.some(function (s) { return s.id === st.left; })) st.left = v.left[0].id;
    if (!v.right.some(function (s) { return s.id === st.right; })) st.right = v.right[0].id;
    if (!v.photo) st.photoOn = false;
    // texti sem er ekki á lista þessa viðfangs (t.d. eftir skipti manneskja/gæludýr) víkur fyrir fyrsta textanum; "Enginn texti" (tómt) helst
    if (!st.topCustom && st.top && TOPS[st.subject].indexOf(st.top) < 0) st.top = TOPS[st.subject][0];
    if (!st.bottomCustom && st.bottom && BOTTOMS[st.subject].indexOf(st.bottom) < 0) st.bottom = BOTTOMS[st.subject][0];
  }
  function shopVariant() { return findShopifyVariant(key(), st.color, sizeObj(), photoActive(), [leftObj().name, rightObj().name]); }
  // photo surcharge as the store actually charges it (photo variant minus plain variant); README fallback when there is no photo variant
  function photoUpcharge() {
    var v = V(); if (!v.photo) return 0;
    var a = findShopifyVariant(key(), st.color, sizeObj(), true), b = findShopifyVariant(key(), st.color, sizeObj(), false);
    if (a && b && /mynd|photo/.test(norm(a.o.join(" "))) && !/mynd|photo/.test(norm(b.o.join(" ")))) return (a.price - b.price) / 100;
    return v.photo.upcharge;
  }
  function basePrice(k) { var p = GOGN[k]; return (p && p.minPrice) ? p.minPrice / 100 : VARIANTS[k].basePrice; }
  function total() {
    var up = photoActive() ? V().photo.upcharge : 0;
    var sv = shopVariant();
    if (sv) { var hasPhotoOpt = /mynd|photo/.test(norm(sv.o.join(" "))); return sv.price / 100 + (hasPhotoOpt ? 0 : up); }
    return V().basePrice + up;
  }

  // Hringurinn um ljósmyndina (eigandi 2026-09-29): ein skurðlína (LINA), ekki grafið band. Forskoðunin sýnir
  // hana svona breiða (mm); stillt eftir mælingu á skornu línunni.
  var KR_LINA_MM = 0.3;
  // Breidd gamla bandsins í CSS (1,5 px). Vafrinn námundar reiknaða rammann að heilum skjádílum (1 px á venjulegum
  // skjá, 1,5 á retina), svo línan fer á miðju hönnunarbreiddarinnar og skráin verður eins á öllum skjám.
  var KR_BAND_PX = 1.5;

  // ─── Symbol markup ─────────────────────────────────────────────────────────
  function glyph(id) {
    if (id === "none") return '<span class="kr-glyph-none" aria-hidden="true">-</span>';
    if (id === "photo" || id === "eigin-mynd") {
      var src = st.photoDataUrl || ASSET + (id === "photo" ? "sm-kr-portrett-syn.jpg" : "sm-kr-gaeludyr-syn.jpg");
      return '<div class="kr-photo"><img src="' + src + '" alt="" draggable="false"></div>';
    }
    var f = ASSET + "sm-kr-" + id + ".svg";
    // <img> shows the artwork everywhere; on ál the CSS additionally masks the steel gradient through the same file
    return '<img class="kr-glyph" src="' + f + '" alt="" draggable="false">';
  }
  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return root.querySelectorAll(sel); };

  // ─── Render: stage ─────────────────────────────────────────────────────────
  function renderStage() {
    var s = sizeObj(), plate = $(".kr-plate"), r = rightObj(), l = leftObj();
    plate.className = "kr-plate " + (st.color === "white" ? "kr-plate-white" : st.material === "akryl" ? "kr-plate-akryl" : "kr-plate-al");
    plate.style.width = s.w + "px"; plate.style.height = s.h + "px";
    plate.style.setProperty("--kr-lina", +(KR_LINA_MM * s.w / (parseFloat(s.dim) * 10)).toFixed(3) + "px");
    // F1 23.10: dagsetning sem getur ekki staðist (í framtíðinni, eða dánardagur á undan fæðingardegi) er ekki teiknuð í forskoðun ("…");
    // pöntunin stöðvast í kit-inu (sm-vs-kross.js dagsVilla). Gild dagsetning og framleiðsluskráin eru óbreytt.
    var rod = datesInOrder(), b = rod && !dateFuture(st.birth) ? fmtDate(st.birth) : "", d = rod && !dateFuture(st.death) ? fmtDate(st.death) : "";
    // sýnidæmið hverfur um leið og eitthvað er valið; hálfkláruð dagsetning sýnist sem "…" en ekki sem sýnidæmi
    var dates = (dateEmpty(st.birth) && dateEmpty(st.death)) ? SAMPLE_DATES[st.subject] : (b || "…") + " - " + (d || "…");
    plate.innerHTML =
      '<div class="kr-hole kr-hole-l"></div><div class="kr-hole kr-hole-r"></div>' +
      '<div class="kr-icon kr-icon-left" aria-hidden="true">' + (l.id === "none" ? "" : glyph(l.id)) + "</div>" +
      '<div class="kr-center">' + (frjals() ? frjalsarLinur() :
        (topText() ? '<div class="kr-row kr-row-top">' + esc(topText()) + "</div>" : "") +
        '<div class="kr-name">' + esc(st.name || SAMPLE_NAME[st.subject]) + "</div>" +
        (datesHidden() ? "" : '<div class="kr-dates">' + esc(dates) + "</div>") +
        (bottomText() ? '<div class="kr-row kr-row-bottom">' + esc(bottomText()) + "</div>" : "")) +
      "</div>" +
      '<div class="kr-icon kr-icon-right" aria-hidden="true">' + (r.id === "none" ? "" : glyph(r.id)) + "</div>";
    if (nyjarReglur()) fitNy(plate, s);
    else {
      var avail = s.w - 76 - 2 * Math.min(s.w * 0.18, 100) - 44; // icon slots ALWAYS reserved → text always centred
      fit(plate.querySelector(".kr-name"), avail, 26, 13);
      fit(plate.querySelector(".kr-dates"), avail, 12.5, 8.5);
    }
    $$("[data-kr-dim]").forEach(function (el) { el.textContent = s.dim; });
    var se = $("[data-kr-stage-efni]"), sk = $("[data-kr-stage-takn]");
    if (se) se.textContent = (st.material === "akryl" ? "Akrýl" : "Ál") + " · " + COLOR_NAME[st.color].toLowerCase();
    if (sk) sk.textContent = l.name + " + " + r.name;
    var t = kr(total()); $$("[data-kr-total]").forEach(function (el) { el.textContent = t; });
    fitStage();
  }
  // Frjáls hamur: línurnar í röð; texti efst fær spássíu efstu línu og texti neðst þeirrar neðstu, eins og venjulega
  function frjalsarLinur() {
    var L = linurFrjals();
    return L.map(function (l, i) {
      if (l.teg === "nafn") return '<div class="kr-name">' + esc(l.t) + "</div>";
      if (l.teg === "dags") return '<div class="kr-dates">' + esc(l.t) + "</div>";
      return '<div class="kr-row' + (i === 0 ? " kr-row-top" : i === L.length - 1 ? " kr-row-bottom" : "") + '">' + esc(l.t) + "</div>";
    }).join("");
  }
  // Stórt ál og frjáls hamur: breidd (dálkurinn A, nafn og dagsetningar ein lína án lágmarks, línur minnka ef orð er
  // of breitt), svo hæð: öll letur um sama hlutfall (0,02 skref) þar til dálkurinn passar á plötuna. framLikan reiknar eins.
  function fitNy(plate, s) {
    var A = textaBreidd(s), center = plate.querySelector(".kr-center");
    if (stortAl()) Array.prototype.forEach.call(plate.querySelectorAll(".kr-hole"), function (h) {
      var d = GAT_MM * s.w / plotuMm(s);
      h.style.width = h.style.height = d + "px";
      h.style[h.classList.contains("kr-hole-r") ? "right" : "left"] = (KR_GAT_BRUN + KR_GAT_PX / 2 - d / 2) + "px";
    });
    if (!center) return;
    center.style.maxWidth = A + "px";
    var els = Array.prototype.filter.call(center.children, function (el) { return /\bkr-(name|dates|row)\b/.test(el.className); });
    var base = els.map(function (el) {
      var cl = el.classList, b0 = cl.contains("kr-name") ? 26 : cl.contains("kr-dates") ? 12.5 : parseFloat(getComputedStyle(el).fontSize) || 13.5;
      el.setAttribute("data-kr-fs", b0);
      fit(el, A, b0, KR_MIN_PX);
      return parseFloat(el.style.fontSize);
    });
    if (frjals()) {
      base = jafnaTeg(els.map(tegEl), base);
      els.forEach(function (el, i) { el.style.fontSize = base[i] + "px"; });
    }
    var pcs = getComputedStyle(plate), ch = s.h - (parseFloat(pcs.paddingTop) || 0) - (parseFloat(pcs.paddingBottom) || 0);
    var haed = function () { var hp = plate.getBoundingClientRect().height; return hp ? center.getBoundingClientRect().height / hp * s.h : 0; };
    var r = 1, g = 0;
    while (haed() - ch > 0.01 && r > 0.2 && g++ < 60) {
      r = kvarda(r - 0.02);
      els.forEach(function (el, i) { el.style.fontSize = kvarda(base[i] * r) + "px"; });
    }
  }
  function tegEl(el) { var cl = el.classList; return cl.contains("kr-name") ? "nafn" : cl.contains("kr-dates") ? "dags" : "rod"; }
  // Frjáls hamur: allar línur sömu tegundar jafnstórar (minnsta stærðin), t.d. bæði nöfnin og báðar dagsetningar hjóna
  function jafnaTeg(teg, fs) {
    var minst = {};
    teg.forEach(function (t, i) { minst[t] = Math.min(minst[t] == null ? Infinity : minst[t], fs[i]); });
    return teg.map(function (t) { return minst[t]; });
  }
  function fit(el, avail, max, min) { if (!el) return; var fs = max; el.style.fontSize = fs + "px"; var g = 0; while (el.scrollWidth > avail && fs > min && g++ < 90) { fs -= 0.5; el.style.fontSize = fs + "px"; } }
  function fitStage() {
    var c = $(".kr-canvas"), p = $(".kr-plate"); if (!c || !p) return;
    var f = Math.min(1, (c.clientWidth - 12) / p.offsetWidth, (c.clientHeight - 14) / p.offsetHeight);
    p.style.transform = f < 1 ? "scale(" + f.toFixed(4) + ")" : "";
  }

  // photo drop. Skráin sjálf er geymd í photoFile og fer með pöntuninni; forskoðunin sýnir hana um blob-slóð (st.photoDataUrl)
  var drop = $("[data-kr-drop]");
  function dropUrl() { if (st.photoDataUrl) { try { URL.revokeObjectURL(st.photoDataUrl); } catch (_) {} st.photoDataUrl = ""; } }
  function clearPhoto() { photoFile = null; dropUrl(); st.photoName = ""; var fi = drop && drop.querySelector("input[type=file]"); if (fi) fi.value = ""; }
  function isImage(f) { return /^image\//.test(f.type || "") || /\.(jpe?g|png|gif|webp|heic|heif|tiff?|avif|bmp)$/i.test(f.name || ""); }
  function mbTxt(b) { return (Math.ceil(b / MB * 10) / 10).toString().replace(".", ",") + " MB"; }
  function readPhoto(f) {
    if (!f) return;
    photoErr = !isImage(f) ? "Þetta er ekki myndaskrá. Veldu ljósmynd." : f.size === 0 ? "Skráin er tóm. Veldu aðra mynd." : f.size > PHOTO_MAX ? "Myndin er " + mbTxt(f.size) + " en má mest vera 19 MB. Veldu minni mynd." : "";
    // ógild skrá: fyrri mynd (ef einhver) helst valin og villan segir hvers vegna nýja skráin var ekki tekin
    if (photoErr) { var fi = drop && drop.querySelector("input[type=file]"); if (fi) fi.value = ""; render(); return; }
    dropUrl(); photoFile = f; st.photoName = f.name; st.photoOsynileg = false;
    // blob-slóð í stað data-URL (plötunni er endurteiknað við hvern staf). Mynd sem vafrinn getur ekki sýnt (t.d. HEIC í Chrome)
    // fer samt með pöntuninni; forskoðunin sýnir þá sýnishornið í stað brotinnar myndar.
    var url = "", im = new Image();
    try { url = URL.createObjectURL(f); } catch (_) {}
    im.onload = function () { if (photoFile === f) { st.photoDataUrl = url; framMyndAfrita(f, im, url); render(); } else { try { URL.revokeObjectURL(url); } catch (_) {} } };
    im.onerror = function () {
      try { URL.revokeObjectURL(url); } catch (_) {}
      if (photoFile === f) { st.photoOsynileg = true; render(); }
    };
    if (url) im.src = url;
    render();
  }
  if (drop) {
    drop.querySelector("input").addEventListener("change", function (e) { readPhoto(e.target.files[0]); });
    drop.addEventListener("dragover", function (e) { e.preventDefault(); drop.classList.add("over"); });
    drop.addEventListener("dragleave", function () { drop.classList.remove("over"); });
    drop.addEventListener("drop", function (e) { e.preventDefault(); drop.classList.remove("over"); try { drop.querySelector("input").files = e.dataTransfer.files; } catch (_) {} readPhoto(e.dataTransfer.files[0]); });
  }
  window.addEventListener("resize", fitStage);
  window.addEventListener("orientationchange", function () { setTimeout(fitStage, 60); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(renderStage);

  // Vinstra/Hægra megin fylgja Shopify-vörunni: á gæludýraskilti úr áli er "Eigin mynd" vinstra megin og loppan hægra megin.
  // Dagsetningar eru nákvæmlega eins og valið var ("1956", "janúar 1956" eða "1. janúar 1956"). Ljósmyndin sjálf er skráin (sjá addToCart).
  function properties() {
    var p = {
      "Útgáfa": st.subject === "pet" ? "Gæludýr" : "Manneskja",
      "Efni": (st.material === "akryl" ? "Akrýl" : "Ál") + " - " + COLOR_NAME[st.color],
      "Stærð": sizeObj().dim,
      "Vinstra megin": leftObj().name,
      "Hægra megin": rightObj().name,
      "Nafn": st.name.trim(),
      "Fæðingardagur": fmtDate(st.birth),
      "Dánardagur": fmtDate(st.death)
    };
    if (frjals()) {
      delete p["Nafn"]; delete p["Fæðingardagur"]; delete p["Dánardagur"];
      p["Texti"] = linurFrjals().map(function (l) { return l.t; }).join(" / ");
    } else {
      p["Texti efst"] = topText() || NO_TEXT;
      p["Texti neðst"] = bottomText() || NO_TEXT;
    }
    if (photoActive() && photoFile) p["Ljósmynd"] = st.photoName;
    if (st.notes) p["Athugasemdir með pöntun"] = st.notes;
    /* CK 19.10 (QA2 10, QA10 6): a pet plaque without dates has only the name to check */
    p["Staðfest af viðskiptavini"] = datesOptional() && datesNone() ? "Já - nafn yfirfarið" : "Já - nafn og dagsetningar yfirfarnar";
    return p;
  }
  // ─── Framleiðsluskrá fyrir xTool (SMFram) ─────────────────────────────────
  // Með hverri línu fer SVG í mm af plötunni eins og forskoðunin sýnir hana, reiknuð óháð vafra (framLikan, CU 19.10):
  // allur texti sem ferlar úr leturskrám SMFram (efri og neðri texti Fraunces, nafnið Tinos, dagsetningar Montserrat),
  // tákn eigandans rakin úr teikningu þeirra í reiknuðum hólfum, ljósmyndin sem grátóna mynd (svart = grafið).
  // Akrýl: platan og götin eru SKERA. Ál: útlína og göt eru aðeins UTLINA (til að stilla upp). Stórt ál (24.10): útlínan
  // UTLINA, 4 mm göt grafin; keyrsla 1 (GRAFA) = vinstra tákn, allur texti, vinstra gat; keyrsla 2 (KEYRSLA-2) = hægra merki og gat.
  // Skráin má aldrei tefja eða stöðva kaupin: allt innan 2,5 s, annars fer línan án hennar.
  var FRAM = { tima: 2500, rakPxMm: 20, taknPxMm: 28, myndPxMm: 12, hamarkPx: 6e6, minMm: 0.06, sneid: 8, bida: 600 };
  function framTala(n) { return Math.round(n * 1e4) / 1e4; }
  // Rakning (marching squares, línuleg brúun við 0,5): gildi 0..1 á W x H neti -> lokaðar útlínur í dílum.
  // Fyllti flöturinn er alltaf vinstra megin, svo göt snúast öfugt og nonzero-sameining SMFram er rétt.
  // Blettir og göt minni en um 0,06 x 0,06 mm (undir upplausn leysisins) falla út (minFl, dílar í öðru veldi).
  // Unnið í skrefum: skref(til) vinnur þar til klukkan nær til og skilar true þegar allt er búið. Þannig fær
  // vafrinn að teikna og svara á milli sneiða (síðan frýs ekki), og táknin og nafnið eru rakin fyrir fram
  // þegar síðan er aðgerðalaus. Reikniskrefin og röð þeirra eru þau sömu og áður, svo útkoman er sú sama.
  // teikna() skilar striga, gildi(d, a) les gildi díls a (vísir í RGBA-gögnin) úr getImageData.
  function Rakari(teikna, gildi, tol, minFl) { this.teikna = teikna; this.gildi = gildi; this.tol = tol; this.minFl = minFl; this.fasi = 0; this.ut = []; }
  Rakari.prototype.skref = function (til) {
    var s = this;
    while (s.fasi < 4) {
      if (s.fasi === 0) {
        var cv = s.teikna();
        s.cv = cv; s.W = cv.width; s.H = cv.height; s.PW = s.W + 2; s.PH = s.H + 2; s.NH = s.PW * s.PH;
        s.g = new Float32Array(s.NH); s.nx = new Int32Array(2 * s.NH); s.y = 0; s.fasi = s.W > 0 && s.H > 0 ? 1 : 2;
      } else if (s.fasi === 1) rakLesa(s);
      else if (s.fasi === 2) rakRod(s);
      else rakFylgja(s);
      if (s.fasi < 4 && Date.now() >= til) return false;
    }
    return true;
  };
  // Strigann lesinn í böndum (um 1 MB í senn) inn í netið með eins díls ramma
  function rakLesa(s) {
    var band = Math.max(1, Math.min(s.H - s.y, Math.floor(262144 / s.W))), d = s.cv.getContext("2d").getImageData(0, s.y, s.W, band).data, x, y;
    for (y = 0; y < band; y++) { var o = (s.y + y + 1) * s.PW + 1, j0 = y * s.W; for (x = 0; x < s.W; x++) s.g[o + x] = s.gildi(d, (j0 + x) * 4); }
    s.y += band;
    if (s.y >= s.H) { s.cv = null; s.y = 0; s.fasi = 2; }
  }
  // Ein röð ferninga
  function rakRod(s) {
    var g = s.g, nx = s.nx, PW = s.PW, NH = s.NH, y = s.y, x;
    for (x = 0; x < PW - 1; x++) {
      var ia = y * PW + x, a = g[ia], b = g[ia + 1], c = g[ia + PW + 1], d = g[ia + PW];
      var k = (a >= 0.5 ? 8 : 0) | (b >= 0.5 ? 4 : 0) | (c >= 0.5 ? 2 : 0) | (d >= 0.5 ? 1 : 0);
      if (k === 0 || k === 15) continue;
      var T = ia, B = ia + PW, L = NH + ia, R = NH + ia + 1, midja = (a + b + c + d) / 4 >= 0.5;
      switch (k) {
        case 1: nx[B] = L + 1; break;
        case 2: nx[R] = B + 1; break;
        case 3: nx[R] = L + 1; break;
        case 4: nx[T] = R + 1; break;
        case 5: if (midja) { nx[T] = L + 1; nx[B] = R + 1; } else { nx[T] = R + 1; nx[B] = L + 1; } break;
        case 6: nx[T] = B + 1; break;
        case 7: nx[T] = L + 1; break;
        case 8: nx[L] = T + 1; break;
        case 9: nx[B] = T + 1; break;
        case 10: if (midja) { nx[R] = T + 1; nx[L] = B + 1; } else { nx[L] = T + 1; nx[R] = B + 1; } break;
        case 11: nx[R] = T + 1; break;
        case 12: nx[L] = R + 1; break;
        case 13: nx[B] = R + 1; break;
        case 14: nx[L] = B + 1; break;
      }
    }
    s.y = y + 1;
    if (s.y >= s.PH - 1) { s.i = 0; s.fasi = 3; }
  }
  // Útlínurnar raktar, einfaldaðar og síaðar, 16384 brúnir í senn
  function rakFylgja(s) {
    var g = s.g, nx = s.nx, PW = s.PW, NH = s.NH, endir = Math.min(2 * NH, s.i + 16384), i;
    function pkt(id) {
      var h = id < NH, j = h ? id : id - NH, yy = (j / PW) | 0, xx = j - yy * PW, v0 = g[j], v1 = h ? g[j + 1] : g[j + PW], t = (0.5 - v0) / (v1 - v0);
      if (!(t >= 0 && t <= 1)) t = 0.5;
      return h ? [xx + t - 0.5, yy - 0.5] : [xx - 0.5, yy + t - 0.5];
    }
    function flatar(p) { var r = 0; for (var q = 0; q < p.length; q++) { var n2 = p[(q + 1) % p.length]; r += p[q][0] * n2[1] - n2[0] * p[q][1]; } return r / 2; }
    for (i = s.i; i < endir; i++) {
      if (!nx[i]) continue;
      var pts = [], cur = i;
      while (nx[cur]) { pts.push(pkt(cur)); var nn = nx[cur] - 1; nx[cur] = 0; cur = nn; }
      if (pts.length > 2) { var s2 = pts.length > 16 ? einfalda(pts, s.tol) : pts; if (s2.length < 3) s2 = pts; if (Math.abs(flatar(s2)) > s.minFl) s.ut.push(s2); }
    }
    s.i = endir;
    if (s.i >= 2 * NH) { s.g = s.nx = null; s.fasi = 4; }
  }
  // Gildi díls: nafnið = þekja (alfa, aðeins varaleiðin); tákn = þekja sinnum dýpt (dökkt = grafið)
  function framGildiNafn(d, a) { return d[a + 3] / 255; }
  function framGildiTakn(d, a) { return d[a + 3] / 255 * (1 - (0.2126 * d[a] + 0.7152 * d[a + 1] + 0.0722 * d[a + 2]) / 255); }
  // Douglas-Peucker á lokaðri línu
  function einfalda(p, tol) {
    var n = p.length, i, far = 0, fd = -1;
    if (n < 5) return p;
    for (i = 1; i < n; i++) { var dx = p[i][0] - p[0][0], dy = p[i][1] - p[0][1]; if (dx * dx + dy * dy > fd) { fd = dx * dx + dy * dy; far = i; } }
    var keep = new Uint8Array(n + 1), stack = [[0, far], [far, n]], t2 = tol * tol;
    keep[0] = keep[far] = 1;
    while (stack.length) {
      var sg = stack.pop(), a = sg[0], b = sg[1];
      if (b - a < 2) continue;
      var A = p[a % n], Bp = p[b % n], vx = Bp[0] - A[0], vy = Bp[1] - A[1], L2 = vx * vx + vy * vy, mi = -1, md = -1;
      for (var j = a + 1; j < b; j++) {
        var q = p[j % n], wx = q[0] - A[0], wy = q[1] - A[1], cr = vx * wy - vy * wx, dd = L2 ? cr * cr / L2 : wx * wx + wy * wy;
        if (dd > md) { md = dd; mi = j; }
      }
      if (md > t2) { keep[mi] = 1; stack.push([a, mi], [mi, b]); }
    }
    var out = [];
    for (i = 0; i < n; i++) if (keep[i]) out.push(p[i]);
    return out;
  }
  // Útlínur (dílar) -> d í mm: mm = (x0 + díll / R) * k
  function framD(polys, x0, y0, R, k) {
    return polys.map(function (p) {
      return "M" + p.map(function (q) { return Math.round((x0 + q[0] / R) * k * 1000) / 1000 + " " + Math.round((y0 + q[1] / R) * k * 1000) / 1000; }).join("L") + "Z";
    }).join("");
  }
  // Stafir í einingu (grapheme) með rétthyrningi hvers í skjádílum
  function framStafir(el) {
    var out = [], rng = document.createRange(), tw = document.createTreeWalker(el, 4, null, false), n;
    var seg = window.Intl && Intl.Segmenter && Array.from ? new Intl.Segmenter(undefined, { granularity: "grapheme" }) : null;
    while ((n = tw.nextNode())) {
      var t = n.data, hlutar = seg ? Array.from(seg.segment(t)).map(function (x) { return x.segment; }) : (t.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[\s\S]/g) || []), i = 0;
      hlutar.forEach(function (h) {
        rng.setStart(n, i); rng.setEnd(n, i + h.length); i += h.length;
        var rs = rng.getClientRects();
        if (rs.length) out.push({ c: h, l: rs[0].left, r: rs[0].right, t: rs[0].top, b: rs[0].bottom });
      });
    }
    return out;
  }
  // Grunnlína síðustu línu: 0 x 0 kubbur á grunnlínunni (tekinn strax aftur)
  function framGrunnlina(el) {
    var p = document.createElement("span");
    p.style.cssText = "display:inline-block;width:0;height:0;margin:0;padding:0;border:0;vertical-align:baseline";
    el.appendChild(p);
    var y = p.getBoundingClientRect().bottom;
    el.removeChild(p);
    return y;
  }
  // Línur texta (orðaskil í forskoðuninni): [{ t, l, r, top }], og grunnlína hverrar
  function framLinur(el) {
    var st2 = framStafir(el), linur = [], cur = null, base = framGrunnlina(el);
    st2.forEach(function (s) {
      if (!cur || Math.abs(s.t - cur.t0) > (s.b - s.t) * 0.5) { cur = { stafir: [], t0: s.t }; linur.push(cur); }
      cur.stafir.push(s);
    });
    linur = linur.map(function (ln) {
      var sy = ln.stafir.filter(function (s) { return /\S/.test(s.c); });
      if (!sy.length) return null;
      return { t: ln.stafir.map(function (s) { return s.c; }).join("").replace(/^\s+|\s+$/g, ""), l: sy[0].l, r: sy[sy.length - 1].r, top: sy[0].t, stafir: ln.stafir };
    }).filter(Boolean);
    if (linur.length) { var sid = linur[linur.length - 1]; linur.forEach(function (ln) { ln.base = base - (sid.top - ln.top); }); }
    return linur;
  }
  // Rakið (dílar) geymt eftir lykli: tákn eftir tákni og teiknistærð, nafnið eftir letri, stærð og stöðu hvers
  // stafs. Sama tákn eða nafn í sömu stærð er aðeins rakið einu sinni (líka það sem var rakið fyrir fram).
  var framRakid = {}, framRodun = [];
  function framGeyma(lyk, polys) {
    if (!lyk || !polys || !polys.length || framRakid[lyk]) return;
    framRakid[lyk] = polys; framRodun.push(lyk);
    while (framRodun.length > 24) delete framRakid[framRodun.shift()];
  }
  // Eitt rakningarverk: úr skyndiminni strax, í verk-listann (rakið síðar í sneiðum) eða strax (frest = tímamörk).
  // v = { lyk, nyr() -> skref-hlutur, fylla(útkoma), el, villa }
  function framVerk(v, verk, frest) {
    if (v.lyk && framRakid[v.lyk]) { v.fylla(framRakid[v.lyk]); return; }
    if (verk) { verk.push(v); return; }
    var rk = v.nyr();
    if (!rk.skref(frest || Infinity)) throw new Error("timi");
    framGeyma(v.lyk, rk.ut); v.fylla(rk.ut);
    if (v.el && !v.el.d) throw new Error(v.villa);
  }
  // verk: fylki = ekkert er rakið hér, rakningarverkin fara í það (framVinna rekur þau í sneiðum);
  // verk.forvinnsla = aðeins verið að finna hvað má rekja fyrir fram (ljósmyndin sleppt).
  // ─── Uppsetning skrárinnar óháð vafra (CU 19.10.2026) ─────────────────────
  // Forskoðunin er teiknuð af vafranum, og grunnlína, kerning og námundun eru ólík í Chrome, Safari og Firefox (QA11 F2:
  // nafnið 0,6 mm neðar og stafir 0,5 mm til hliðar). Skráin er því reiknuð hér úr letrinu sjálfu: breiddir og stafastöður
  // úr leturskrám SMFram (sömu skrár og ferlarnir), grunnlínur úr hhea-mælum letranna og platan sett upp eftir reglum
  // sm-krossaskilti.css (flex-röð: tákn | dálkur | tákn, dálkurinn: efri texti, nafn, dagsetningar, neðri texti, línur
  // brotnar eins og text-wrap: balance). Úr síðunni eru aðeins lesin uppgefin CSS-gildi (leturstærð, stafabil og línuhæð
  // sem hlutfall, spássíur, bil) og textarnir sjálfir, aldrei staða eða breidd sem vafrinn reiknaði. Bútar eru námundaðir
  // í 1/64 díl eins og Chrome gerir, svo skráin er nánast sú sama og Chrome-skráin var.
  var LETUR_MAEL = { // hhea ascender, descender, unitsPerEm (vefletrið og sm-letur-*.json hafa sömu mæla)
    "tinos-400": [1825, 443, 2048], "fraunces-italic-300": [7824, 2040, 8000], "montserrat-400": [7744, 2008, 8000]
  };
  var TINOS = "tinos-400";
  function luF(v) { return Math.floor(v * 64 + 1e-7) / 64; }
  function luC(v) { return Math.ceil(v * 64 - 1e-7) / 64; }
  function hlutf(a, b, n) { var p = Math.pow(10, n); return b ? Math.round(a / b * p) / p : 0; }
  // Tinos skráð í SMFram (letrið í forskoðuninni: Google-skrárnar latin og latin-ext, svo gf = engin kerning yfir skilin)
  var tinosSkrad = false;
  function framSkraTinos() {
    var F = window.SMFram;
    if (tinosSkrad || !F || !F.skraLetur) return !!F;
    F.skraLetur(TINOS, { nafn: "Tinos", thykkt: 400, uppruni: "google/fonts ofl/tinos/Tinos-Regular.ttf Version 1.340", url: ASSET + "sm-letur-tinos-400.json", gf: true });
    tinosSkrad = true;
    return true;
  }
  // Uppsetning eins texta í 1 mm (línuleg í stærð): b = breidd, g = [{ c (kóðapunktur), x, w, bil }] (SMFram uppsetning)
  var framMal = {}, framMalRod = [];
  // Tákn eigandans sem fastar útlínur (sm-kr-takn-<id>.json): rakin EINU SINNI í 2048 dílum (prof/takn-byggja.mjs), svo
  // skráin ræðst ekki af því hvernig vafri kaupandans teiknar SVG-skrána (jaðarslétting gaf allt að 0,34 mm frávik).
  // Hnit í 1/10000 af teiknuðum kassa táknsins, hl = breidd/hæð úr viewBox. Vanti skrána er rakið úr teikningu vafrans.
  var framTakn = {}, framTaknVilla = {};
  function framTaknD(o, dx, dy, dw, dh, k) {
    var tol = 0.5 / FRAM.taknPxMm, minF = FRAM.minMm * FRAM.minMm, ut = [];
    o.p.forEach(function (a) {
      var pts = [];
      for (var i = 0; i + 1 < a.length; i += 2) pts.push([(dx + a[i] / 1e4 * dw) * k, (dy + a[i + 1] / 1e4 * dh) * k]);
      if (pts.length < 3) return;
      var s2 = pts.length > 16 ? einfalda(pts, tol) : pts;
      if (s2.length < 3) s2 = pts;
      var fl = 0;
      for (var q = 0; q < s2.length; q++) { var n2 = s2[(q + 1) % s2.length]; fl += s2[q][0] * n2[1] - n2[0] * s2[q][1]; }
      if (Math.abs(fl / 2) > minF) ut.push("M" + s2.map(function (q) { return Math.round(q[0] * 1000) / 1000 + " " + Math.round(q[1] * 1000) / 1000; }).join("L") + "Z");
    });
    return ut.join("");
  }
  function malLyk(id, ls, t) { return id + "|" + ls + "|" + t; }
  function framMalFa(id, ls, t) { return framMal[malLyk(id, ls, t)] || null; }
  // Það sem skráin þarf að mæla í núverandi stöðu: [id, stafabil (em), texti]
  function framMalVerk() {
    var plate = $(".kr-plate"), ut = [];
    if (!plate) return ut;
    Array.prototype.forEach.call(plate.querySelectorAll(".kr-row, .kr-name, .kr-dates"), function (el) {
      var cs = getComputedStyle(el), fs = parseFloat(cs.fontSize) || 1;
      var id = el.classList.contains("kr-name") ? TINOS : window.SMFram.leturFyrir(cs.fontFamily, cs.fontWeight, cs.fontStyle, true);
      if (id) ut.push([id, hlutf(parseFloat(cs.letterSpacing) || 0, fs, 4), el.textContent]);
    });
    return ut;
  }
  // Sækir letrin og mælir textana (ósamstillt, einu sinni á texta); skilar loforði sem bregst aldrei
  function framUndirbua(hamark) {
    if (!window.SMFram || !window.SMFram._innri || !window.SMFram._innri.uppsetning) return Promise.resolve(false);
    framSkraTinos();
    var verk = framMalVerk().filter(function (v) { return !framMal[malLyk(v[0], v[1], v[2])]; });
    var tvt = [leftObj().id, rightObj().id].filter(function (id) { return id && id !== "none" && id !== "photo" && id !== "eigin-mynd" && !framTakn[id] && !framTaknVilla[id]; });
    if (!verk.length && !tvt.length) return Promise.resolve(true);
    var allt = Promise.all(tvt.map(function (id) {
      return fetch(ASSET + "sm-kr-takn-" + id + ".json").then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (o) {
        if (!o || !o.p || !(o.hl > 0)) throw new Error("takn");
        framTakn[id] = o;
      }).then(null, function () { framTaknVilla[id] = 1; });
    }).concat(verk.map(function (v) {
      return window.SMFram._innri.uppsetning(v[0], { texti: v[2], mm: 1, stafabil: v[1] }).then(function (u) {
        var k = malLyk(v[0], v[1], v[2]);
        if (!framMal[k]) { framMalRod.push(k); while (framMalRod.length > 64) delete framMal[framMalRod.shift()]; }
        framMal[k] = { b: u.breidd, g: u.gl.map(function (q) { return { c: q.c, x: q.x, w: q.w, bil: !!q.bil }; }) };
      });
    }))).then(function () { return true; }, function () { return false; });
    return Promise.race([allt, new Promise(function (r) { setTimeout(function () { r(false); }, hamark || FRAM.tima); })]);
  }
  // Breidd búts [a, b) af kóðapunktum í 1 mm: frá fyrsta staf til enda þess síðasta, með stafabili á eftir hverjum
  function malBreidd(m, ls, a, b) {
    var x0 = null, x1 = null;
    m.g.forEach(function (q) { if (q.c >= a && q.c < b) { if (x0 === null) x0 = q.x; x1 = q.x + q.w + ls; } });
    return x0 === null ? 0 : x1 - x0;
  }
  function malStart(m, a) { for (var i = 0; i < m.g.length; i++) if (m.g[i].c >= a) return m.g[i].x; return m.b; }
  // Línubrot: orðaskil á bilum; gráðugt, og jafnað eins og text-wrap: balance (minnsta breidd sem heldur línufjöldanum)
  function framBrjota(cps, m, ls, fs, maxW) {
    var ord = [], a = 0, i;
    for (i = 0; i <= cps.length; i++) if (i === cps.length || /\s/.test(cps[i])) { if (i > a) ord.push([a, i]); a = i + 1; }
    if (!ord.length) return [];
    function gradugt(W) {
      var linur = [], s = 0;
      while (s < ord.length) {
        var e = s + 1;
        while (e < ord.length && malBreidd(m, ls, ord[s][0], ord[e][1]) * fs <= W + 1e-6) e++;
        linur.push([ord[s][0], ord[e - 1][1]]); s = e;
      }
      return linur;
    }
    var L = gradugt(maxW);
    if (L.length < 2 || L.length > 6) return L;
    var lo = 0, hi = maxW;
    while (hi - lo > 1 / 64) { var mid = (lo + hi) / 2; if (gradugt(mid).length <= L.length) hi = mid; else lo = mid; }
    return gradugt(hi);
  }
  // Fit eins og fit() síðunnar (scrollWidth > avail, 0,5 px skref), reiknað úr letrinu
  function framPassa(m, fs, avail, min) { var g = 0; while (Math.round(luC(m.b * fs)) > avail && fs > min && g++ < 90) fs -= 0.5; return fs; }
  // Sama fyrir línu sem brotnar (fit() á .kr-row, nýju reglurnar): aðeins breiðasta orðið getur farið út fyrir dálkinn
  function framPassaOrd(cps, m, ls, fs, avail, min) {
    var mest = 0, a = 0, i, g = 0;
    for (i = 0; i <= cps.length; i++) if (i === cps.length || /\s/.test(cps[i])) { if (i > a) mest = Math.max(mest, malBreidd(m, ls, a, i)); a = i + 1; }
    while (Math.round(luC(mest * fs)) > avail && fs > min && g++ < 90) fs -= 0.5;
    return fs;
  }
  // Platan reiknuð: { iconL, iconR (kassar í dílum plötunnar), linur: [{ teg, id, fs, ls, t, cps, m, x (miðja), base, b }] }
  function framLikan(s) {
    var plate = $(".kr-plate"), center = plate && plate.querySelector(".kr-center");
    if (!plate || !center || !window.SMFram) return null;
    var W = s.w, H = s.h, pcs = getComputedStyle(plate), ccs = getComputedStyle(center);
    var pl = parseFloat(pcs.paddingLeft) || 0, pr2 = parseFloat(pcs.paddingRight) || 0, pt = parseFloat(pcs.paddingTop) || 0, pb = parseFloat(pcs.paddingBottom) || 0;
    var gx = parseFloat(pcs.columnGap) || 0, gy = parseFloat(ccs.rowGap) || 0, cw = W - pl - pr2, ch = H - pt - pb;
    var avail = W - 76 - 2 * Math.min(W * 0.18, 100) - 44; // sama og renderStage (fit)
    var ny = nyjarReglur(), A = textaBreidd(s); // stórt ál og frjáls hamur: sama og fitNy
    var atr = [], ok = true;
    Array.prototype.forEach.call(center.children, function (el) {
      var cl = el.classList, teg = cl.contains("kr-name") ? "nafn" : cl.contains("kr-dates") ? "dags" : cl.contains("kr-row") ? "rod" : "";
      if (!teg) return;
      var cs = getComputedStyle(el), fs0 = parseFloat(cs.fontSize) || 1;
      var id = teg === "nafn" ? TINOS : window.SMFram.leturFyrir(cs.fontFamily, cs.fontWeight, cs.fontStyle, true);
      var ls = hlutf(parseFloat(cs.letterSpacing) || 0, fs0, 4), t = el.textContent, m = id && framMalFa(id, ls, t);
      if (!m || !LETUR_MAEL[id]) { ok = false; return; }
      var lh = hlutf(parseFloat(cs.lineHeight), fs0, 2);
      if (!(lh > 0)) lh = 1.2;
      var cps = Array.from ? Array.from(t) : t.split(""), fs;
      if (ny) fs = teg === "nafn" ? framPassa(m, 26, A, KR_MIN_PX) : teg === "dags" ? framPassa(m, 12.5, A, KR_MIN_PX) : framPassaOrd(cps, m, ls, parseFloat(el.getAttribute("data-kr-fs")) || fs0, A, KR_MIN_PX);
      else fs = teg === "nafn" ? framPassa(m, 26, avail, 13) : teg === "dags" ? framPassa(m, 12.5, avail, 8.5) : fs0;
      atr.push({ teg: teg, id: id, fs: fs, fsB: fs, lh: lh, ls: ls, t: t, cps: cps, m: m, LH: luF(lh * fs),
        mt: parseFloat(cs.marginTop) || 0, mb: parseFloat(cs.marginBottom) || 0, brot: teg === "rod", mx: luC(m.b * fs) });
    });
    if (!ok || !atr.length) return null;
    if (ny && frjals()) {
      var jofn = jafnaTeg(atr.map(function (a) { return a.teg; }), atr.map(function (a) { return a.fs; }));
      atr.forEach(function (a, i) { a.fs = a.fsB = jofn[i]; a.LH = luF(a.lh * a.fs); a.mx = luC(a.m.b * a.fs); });
    }
    // Lárétt: tvö jafnbreið táknhólf (CSS .kr-icon: 18 %, mest 100 px) og dálkurinn á milli, allt fyrir miðju
    var iw = Math.min(luF(0.18 * cw), 100), colMax, colW, x0, colX, cx, colH;
    function uppsetja() {
      colMax = Math.max.apply(null, atr.map(function (a) { return a.mx; }));
      colW = Math.max(0, Math.min(colMax, ny ? A : Infinity, cw - 2 * iw - 2 * gx)); x0 = pl + luF((cw - (2 * iw + 2 * gx + colW)) / 2);
      colX = x0 + iw + gx; cx = colX + colW / 2;
      // Lóðrétt: línur hvers hlutar, dálkurinn fyrir miðju
      colH = 0;
      atr.forEach(function (a, i) {
        a.lin = a.brot ? framBrjota(a.cps, a.m, a.ls, a.fs, colW) : [[0, a.cps.length]];
        if (!a.lin.length) a.lin = [[0, 0]];
        colH += (i ? gy : 0) + a.mt + a.lin.length * a.LH + a.mb;
      });
    }
    uppsetja();
    // Nýju reglurnar: of hár dálkur minnkar öll letur um sama hlutfall, eins og fitNy
    var r = 1, g = 0;
    while (ny && colH - ch > 0.01 && r > 0.2 && g++ < 60) {
      r = kvarda(r - 0.02);
      atr.forEach(function (a) { a.fs = kvarda(a.fsB * r); a.LH = luF(a.lh * a.fs); a.mx = luC(a.m.b * a.fs); });
      uppsetja();
    }
    var y = pt + luF((ch - colH) / 2), linur = [];
    atr.forEach(function (a, i) {
      y += (i ? gy : 0) + a.mt;
      // grunnlína eins og Chrome setur hana: hæð og dýpt letursins námunduð í heila díla, hálft línubil niður í heilan díl
      var M = LETUR_MAEL[a.id], asc = Math.round(M[0] * a.fs / M[2]), dsc = Math.round(M[1] * a.fs / M[2]);
      a.lin.forEach(function (ln, j) {
        var t = a.cps.slice(ln[0], ln[1]).join(""), b = malBreidd(a.m, a.ls, ln[0], ln[1]) * a.fs;
        linur.push({ teg: a.teg, id: a.id, fs: a.fs, ls: a.ls, t: t, x: cx, base: y + j * a.LH + asc + Math.floor((a.LH - (asc + dsc)) / 2), b: b,
          vinstri: cx - b / 2 - malStart(a.m, ln[0]) * a.fs, m: a.m, a: ln[0], e: ln[1] });
      });
      y += a.lin.length * a.LH + a.mb;
    });
    var iy = pt + luF((ch - iw) / 2);
    return { iconL: { x: x0, y: iy, w: iw, h: iw }, iconR: { x: colX + colW + gx, y: iy, w: iw, h: iw }, linur: linur };
  }
  function framSpec(frest, anRakn, verk) {
    var s = sizeObj(), plate = $(".kr-plate");
    var m = /(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/.exec(s.dim || "");
    if (!plate || !m || !plate.offsetWidth) throw new Error("plata");
    var Wmm = parseFloat(m[1].replace(",", ".")) * 10, Hmm = parseFloat(m[2].replace(",", ".")) * 10;
    // CU 19.10: allt sem fer í skrána er reiknað úr letrinu og CSS-reglunum (framLikan), ekki úr teikningu vafrans.
    // Án mælinga (letur hlóðst ekki eða stafur vantar í það): eins og fyrir CU, mælt úr síðunni.
    var L = framLikan(s);
    var pr = plate.getBoundingClientRect(), f = pr.width / plate.offsetWidth, k = Wmm / s.w, T = framTala;
    var R = FRAM.rakPxMm * k, tol = 0.5;
    function lx(v) { return (v - pr.left) / f; }             // skjádílar -> dílar plötunnar
    function ly(v) { return (v - pr.top) / f; }
    function kassi(el) { var r = el.getBoundingClientRect(); return { x: lx(r.left), y: ly(r.top), w: r.width / f, h: r.height / f }; }
    var hlutir = [], gogn = { k: T(k), tokn: [] }, akryl = st.material === "akryl", nm = plate.querySelector(".kr-name"), stort = stortAl();
    // Platan og götin (götin eru föst í CSS: 11 px, 20 px frá brún, á miðri hæð)
    hlutir.push({ gerd: "rett", lag: akryl ? "SKERA-YTRA" : "UTLINA", x: 0, y: 0, w: Wmm, h: Hmm, r: T((parseFloat(getComputedStyle(plate).borderTopLeftRadius) || 0) * k) });
    // Stórt ál (24.10): 4 mm göt GRAFIN sem fylltur hringur á föstu miðjunum, vinstra í keyrslu 1, hægra í keyrslu 2
    if (stort) [["GRAFA", KR_GAT_BRUN + KR_GAT_PX / 2], ["KEYRSLA-2", s.w - KR_GAT_BRUN - KR_GAT_PX / 2]].forEach(function (g) {
      hlutir.push({ gerd: "hringur", lag: g[0], cx: T(g[1] * k), cy: T(s.h / 2 * k), r: GAT_MM / 2 });
    });
    else Array.prototype.forEach.call(plate.querySelectorAll(".kr-hole"), function (h) {
      var r = h.getBoundingClientRect();
      hlutir.push({ gerd: "hringur", lag: akryl ? "SKERA-INNRA" : "UTLINA", cx: T(lx((r.left + r.right) / 2) * k), cy: T(ly((r.top + r.bottom) / 2) * k), r: T(r.width / f / 2 * k) });
    });
    if (L) {
      // Allur texti sem ferlar úr leturskrám SMFram (nafnið í Tinos), á reiknuðum stöðum
      L.linur.forEach(function (ln) {
        hlutir.push({ gerd: "texti", lag: "GRAFA", texti: ln.t, letur: ln.id, mm: T(ln.fs * k), x: T(ln.x * k), y: T(ln.base * k), jofnun: "midja", stafabil: ln.ls });
        if (ln.teg === "nafn" && !gogn.nafn) {
          var stafX = [];
          ln.m.g.forEach(function (q) { if (q.c >= ln.a && q.c < ln.e) stafX.push(T((ln.vinstri + q.x * ln.fs) * k)); });
          gogn.nafn = { texti: frjals() ? ln.t : st.name.trim(), letur: TINOS, px: ln.fs, mm: T(ln.fs * k), y: T(ln.base * k), stafir: stafX };
        }
      });
    } else {
      // Varaleið (letur eða mæling náðist ekki, t.d. stafur sem Tinos hefur ekki): eins og fyrir CU, línur og grunnlínur
      // úr síðunni og nafnið rakið úr teikningu vafrans. Skráin verður þá til, en ræðst af vafranum.
      // Efri og neðri texti og dagsetningar: ferlar úr leturskrám SMFram, línur og grunnlínur úr síðunni
      Array.prototype.forEach.call(plate.querySelectorAll(".kr-row, .kr-dates"), function (el) {
        var cs = getComputedStyle(el), fs = parseFloat(cs.fontSize), ls = parseFloat(cs.letterSpacing) || 0;
        var id = window.SMFram.leturFyrir(cs.fontFamily, cs.fontWeight, cs.fontStyle, true);
        if (!id) throw new Error("letur " + cs.fontFamily);
        framLinur(el).forEach(function (ln) {
          hlutir.push({ gerd: "texti", lag: "GRAFA", texti: ln.t, letur: id, mm: T(fs * k), x: T(lx((ln.l + ln.r) / 2) * k), y: T(ly(ln.base) * k), jofnun: "midja", stafabil: T(ls / fs) });
        });
      });
      // Nafnið: teiknað staf fyrir staf á sömu staði og í forskoðuninni, svo rakið
      if (nm) {
        var ncs = getComputedStyle(nm), nfs = parseFloat(ncs.fontSize), nl = framLinur(nm);
        if (nl.length) {
          var stafX = [];
          nl.forEach(function (ln) { ln.stafir.forEach(function (sx) { stafX.push(T(lx(sx.l) * k)); }); });
          gogn.nafn = { texti: st.name.trim(), letur: TINOS, px: nfs, mm: T(nfs * k), y: T(ly(nl[0].base) * k), stafir: stafX };
          if (!anRakn) {
            var L0 = Math.min.apply(null, nl.map(function (x) { return x.l; })), R0 = Math.max.apply(null, nl.map(function (x) { return x.r; }));
            var x0 = lx(L0) - nfs * 0.6, y0 = ly(nl[0].base) - nfs * 1.25, bw = (R0 - L0) / f + nfs * 1.2, bh = nfs * 1.8 + (nl.length - 1) * nfs * 1.2, Rn = R;
            if (bw * bh * Rn * Rn > FRAM.hamarkPx) Rn = Math.sqrt(FRAM.hamarkPx / (bw * bh));
            var W = Math.ceil(bw * Rn), H = Math.ceil(bh * Rn), font = ncs.fontStyle + " " + ncs.fontWeight + " " + (nfs * Rn) + "px " + ncs.fontFamily, stafirN = [];
            nl.forEach(function (ln) {
              ln.stafir.forEach(function (sx) { if (/\S/.test(sx.c)) stafirN.push([sx.c, (lx(sx.l) - x0) * Rn, (ly(ln.base) - y0) * Rn]); });
            });
            var teiknaNafn = function () {
              var cv = document.createElement("canvas"), cx = cv.getContext("2d", { willReadFrequently: true });
              cv.width = W; cv.height = H;
              cx.font = font;
              cx.fillStyle = "#000"; cx.textBaseline = "alphabetic";
              if ("letterSpacing" in cx) cx.letterSpacing = "0px";
              stafirN.forEach(function (q) { cx.fillText(q[0], q[1], q[2]); });
              return cv;
            };
            var elN = { gerd: "slod", lag: "GRAFA", d: "", rakid: "nafn" }, minN = Math.pow(FRAM.minMm * Rn / k, 2);
            hlutir.push(elN);
            framVerk({ lyk: "nafn|" + font + "|" + W + "x" + H + "|" + stafirN.map(function (q) { return q[0] + q[1].toFixed(3) + "," + q[2].toFixed(3); }).join(";"),
              nyr: function () { return new Rakari(teiknaNafn, framGildiNafn, tol, minN); },
              fylla: function (p) { elN.d = framD(p, x0, y0, Rn, k); }, el: elN, villa: "nafn" }, verk, frest);
            gogn.nafn.rakid = T(Rn / k);
          }
        }
      }
    }
    // Tákn eigandans (SVG) og ljósmyndin, í reiknuðu táknhólfunum
    // Stórt ál: hægra merkið í keyrslu 2 (KEYRSLA-2), annars allt GRAFA
    [["vinstri", ".kr-icon-left", leftObj(), L && L.iconL, "GRAFA"], ["haegri", ".kr-icon-right", rightObj(), L && L.iconR, stort ? "KEYRSLA-2" : "GRAFA"]].forEach(function (h) {
      var box = plate.querySelector(h[1]), img = box && box.querySelector("img.kr-glyph"), ph = box && box.querySelector(".kr-photo");
      if (img) {
        var b = h[3] || kassi(img), bx = b.x, by = b.y, bw2 = b.w, bh2 = b.h;
        var fast = framTakn[h[2].id];
        var hl = fast ? fast.hl : img.naturalWidth && img.naturalHeight ? Math.round(img.naturalWidth / img.naturalHeight * 1e5) / 1e5 : 1, op = framStada(getComputedStyle(img).objectPosition);
        var dw = Math.min(bw2, bh2 * hl), dh = dw / hl, dx = bx + (bw2 - dw) * op[0], dy = by + (bh2 - dh) * op[1], Rt = FRAM.taknPxMm * k;
        gogn.tokn.push({ hlid: h[0], id: h[2].id, x: T(dx * k), y: T(dy * k), w: T(dw * k), h: T(dh * k) });
        if (anRakn) return;
        if (fast) { hlutir.push({ gerd: "slod", lag: h[4], d: framTaknD(fast, dx, dy, dw, dh, k), rakid: "takn" }); return; }
        if (verk && verk.forvinnsla && !(img.complete && img.naturalWidth)) { verk.bidur = img; return; }
        if (dw * dh * Rt * Rt > FRAM.hamarkPx) Rt = Math.sqrt(FRAM.hamarkPx / (dw * dh));
        var sw = dw * Rt, sh = dh * Rt, W2 = Math.ceil(sw) + 4, H2 = Math.ceil(sh) + 4;
        var teiknaTakn = function () {
          var c2 = document.createElement("canvas"), x2 = c2.getContext("2d", { willReadFrequently: true });
          c2.width = W2; c2.height = H2;
          x2.drawImage(img, 2, 2, sw, sh);
          return c2;
        };
        var elT = { gerd: "slod", lag: h[4], d: "", rakid: "takn" }, minT = Math.pow(FRAM.minMm * Rt / k, 2);
        hlutir.push(elT);
        framVerk({ lyk: h[2].id + "|" + sw.toFixed(3) + "x" + sh.toFixed(3),
          nyr: function () { return new Rakari(teiknaTakn, framGildiTakn, 0.5, minT); },
          fylla: function (p) { elT.d = framD(p, dx - 2 / Rt, dy - 2 / Rt, Rt, k); }, el: elT, villa: "takn " + h[2].id }, verk, frest);
      } else if (ph && !anRakn && !(verk && verk.forvinnsla)) framMynd(ph, h[3] || kassi(ph), f, k, hlutir, gogn, verk);
    });
    var pr2 = properties(), lysing = {};
    Object.keys(pr2).forEach(function (k2) { if (k2 !== "Athugasemdir með pöntun" && k2 !== "Staðfest af viðskiptavini") lysing[k2] = pr2[k2]; });
    // Á dökkri plötu er ljósmyndin í skránni þegar snúið við (svart = grafið, sést ljóst á plötunni)
    if (stort) lysing["Keyrslur"] = KEYRSLUR;
    if (gogn.mynd && gogn.mynd.ljostGrafid) lysing["Ljósmynd í skrá"] = "Þegar snúið við fyrir svarta plötu (svart = grafið, sést ljóst). Ekki snúa henni við (Invert) í XCS.";
    var spec = { vara: st.subject === "pet" ? "krossaskilti-gaeludyr" : "krossaskilti", efni: st.material + "-" + (st.color === "white" ? "hvitt" : "svart"),
      staerd: s.id === "S" ? "litid" : "stort", ord: frjals() ? ((linurFrjals().filter(function (l) { return l.teg === "nafn"; })[0] || linurFrjals()[0]).t.trim()) : st.name.trim(), snid: "krossaskilti@1", w: Wmm, h: Hmm, lysing: lysing, gogn: gogn, hlutir: hlutir };
    // JSON fyrir pöntunina: án rakinna ferla (þeir eru í skránni), gogn segja hvað var rakið og hvar
    var json = {}, kk;
    for (kk in spec) if (spec.hasOwnProperty(kk)) json[kk] = spec[kk];
    json.hlutir = hlutir.filter(function (e) { return !e.rakid; });
    return { spec: spec, json: json };
  }
  function framStada(v) {
    var p = String(v || "").split(/\s+/).map(function (x) { return /%$/.test(x) ? parseFloat(x) / 100 : 0.5; });
    return [p[0] != null && !isNaN(p[0]) ? p[0] : 0.5, p[1] != null && !isNaN(p[1]) ? p[1] : 0.5];
  }
  // Afkóðað afrit ljósmyndarinnar fyrir framleiðsluskrána, gert í Worker um leið og myndin er valin. Án þess
  // afkóðar körfuhnappurinn alla myndina (12 MP úr síma) á aðalþræðinum: 0,3 til 0,7 s frost á hægum síma.
  // Workerinn afkóðar skrána (createImageBitmap), minnkar hana í 1600 díla skammhlið (OffscreenCanvas) og skilar.
  // Afritið er aðeins notað þegar víst er að það snúi eins og myndin á síðunni: JPEG með EXIF-snúning 1 (eða engan),
  // eða 90 gráðu snúning (5 til 8) sem stærð afkóðuðu myndarinnar staðfestir. Annars er teiknað úr myndinni eins og áður.
  var framAfrit = { url: "", bm: null }, framVinnsla = null;
  var FRAM_VINNSLA = "onmessage=function(e){var d=e.data;createImageBitmap(d.f).then(function(b){" +
    "var rett=b.width===d.w&&b.height===d.h,snuid=b.width===d.h&&b.height===d.w;" +
    "if(!(rett&&(d.o===1||(d.o>=5&&d.w!==d.h)))||typeof OffscreenCanvas==='undefined'){b.close();postMessage({u:d.u,b:null});return;}" +
    "var s=Math.min(1,1600/Math.min(d.w,d.h)),W=Math.max(1,Math.round(d.w*s)),H=Math.max(1,Math.round(d.h*s)),c=new OffscreenCanvas(W,H),x=c.getContext('2d');" +
    "x.imageSmoothingQuality='high';x.drawImage(b,0,0,W,H);b.close();var m=c.transferToImageBitmap();postMessage({u:d.u,b:m},[m]);" +
    "},function(){postMessage({u:d.u,b:null});});};";
  // EXIF-snúningur JPEG-skrár (1 ef enginn), eða 0 ef skráin er ekki JPEG / ekki lesanleg
  function framSnuningur(buf) {
    try {
      var v = new DataView(buf), n = v.byteLength, i = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 0;
      while (i + 4 <= n) {
        var mk = v.getUint16(i), len = v.getUint16(i + 2);
        if (mk === 0xFFE1 && i + 10 <= n && v.getUint32(i + 4) === 0x45786966) {
          var t = i + 10, le = v.getUint16(t) === 0x4949, g16 = function (p) { return v.getUint16(p, le); }, g32 = function (p) { return v.getUint32(p, le); };
          var ifd = t + g32(t + 4), cnt = g16(ifd);
          for (var k = 0; k < cnt; k++) { var e = ifd + 2 + k * 12; if (g16(e) === 0x0112) return g16(e + 8) || 1; }
          return 1;
        }
        if ((mk & 0xFF00) !== 0xFF00 || mk === 0xFFDA) return 1;
        i += 2 + len;
      }
      return 1;
    } catch (er) { return 0; }
  }
  function framMyndAfrita(f, im, url) {
    if (framAfrit.bm && framAfrit.bm.close) { try { framAfrit.bm.close(); } catch (e) {} }
    framAfrit = { url: url, bm: null };
    try {
      var w = im.naturalWidth, h = im.naturalHeight;
      if (!window.Worker || !window.createImageBitmap || !f || !f.slice || w * h < 4e6) return; // lítil mynd teiknast fljótt
      if (!framVinnsla) {
        framVinnsla = new Worker(URL.createObjectURL(new Blob([FRAM_VINNSLA], { type: "text/javascript" })));
        framVinnsla.onmessage = function (e) {
          var d = e.data || {};
          if (d.b && d.u === framAfrit.url && !framAfrit.bm) framAfrit.bm = d.b; else if (d.b && d.b.close) d.b.close();
        };
      }
      var lesa = new FileReader();
      lesa.onload = function () {
        var o = framSnuningur(lesa.result);
        if (framAfrit.url !== url || !o || !(o === 1 || o >= 5)) return;
        framVinnsla.postMessage({ u: url, f: f, w: w, h: h, o: o });
      };
      lesa.readAsArrayBuffer(f.slice(0, 131072));
    } catch (e) {}
  }
  // Ljósmyndin: hringur (ein skurðlína á miðju gamla 1,5 px bandsins) og grátóna mynd innan hans, sömu síur og skurður og í forskoðuninni.
  // Á dökkri plötu grefst ljóst (sést ljóst), á hvítri grefst dökkt. Mynd sem vafrinn sýnir ekki: grænn hringur.
  // Dílarnir eru unnir í röðum (verk: í sneiðum með rakningunni, annars strax).
  function framMynd(ph, kb, f, k, hlutir, gogn, verk) {
    var cs = getComputedStyle(ph), bw = parseFloat(cs.borderTopWidth) || 0;
    var cx = kb.x + kb.w / 2, cy = kb.y + kb.h / 2, ro = kb.w / 2, ri = ro - bw, T = framTala;
    function hringD(r, rett) {
      var a = T((cx - r) * k), c = T((cx + r) * k), y = T(cy * k), rr = T(r * k), sw = rett ? 1 : 0;
      return "M" + a + " " + y + "A" + rr + " " + rr + " 0 1 " + sw + " " + c + " " + y + "A" + rr + " " + rr + " 0 1 " + sw + " " + a + " " + y + "Z";
    }
    // bw = ramminn í CSS (gegnsær, heldur myndinni á sínum stað); línan fer á miðju 1,5 px bandsins
    if (bw > 0) hlutir.push({ gerd: "hringur", lag: "LINA", cx: T(cx * k), cy: T(cy * k), r: T((ro - KR_BAND_PX / 2) * k) });
    var img = ph.querySelector("img");
    if (!st.photoDataUrl || !img || !img.naturalWidth) { hlutir.push({ gerd: "hringur", lag: "UTLINA", cx: T(cx * k), cy: T(cy * k), r: T(ri * k) }); return; }
    var D = Math.max(8, Math.ceil(2 * ri * k * FRAM.myndPxMm)), c = document.createElement("canvas"), x = c.getContext("2d", { willReadFrequently: true });
    c.width = D; c.height = D;
    var iw = img.naturalWidth, ih = img.naturalHeight, sc = Math.max(D / iw, D / ih), op = framStada(getComputedStyle(img).objectPosition);
    var uppruni = framAfrit.bm && framAfrit.url === st.photoDataUrl ? framAfrit.bm : img; // sama mynd, afkóðuð fyrir fram
    if (uppruni !== img) x.imageSmoothingQuality = "high";
    x.drawImage(uppruni, (D - iw * sc) * op[0], (D - ih * sc) * op[1], iw * sc, ih * sc);
    var sia = String(getComputedStyle(img).filter || ""), grar = /grayscale\(([\d.]+)/.exec(sia), kon = /contrast\(([\d.]+)/.exec(sia), bir = /brightness\(([\d.]+)/.exec(sia);
    var gv = grar ? Math.min(1, +grar[1]) : 0, kv = kon ? +kon[1] : 1, bv = bir ? +bir[1] : 1, ljosPlata = st.color === "white";
    var id = x.getImageData(0, 0, D, D), p = id.data, r0 = D / 2, yy = 0;
    var vinnsla = { ut: null, skref: function (til) {
      while (yy < D) {
        for (var xx = 0; xx < D; xx++) {
          var i = (yy * D + xx) * 4, lum = (0.2126 * p[i] + 0.7152 * p[i + 1] + 0.0722 * p[i + 2]) / 255;
          var v = (gv * lum + (1 - gv) * (p[i] + p[i + 1] + p[i + 2]) / 765 - 0.5) * kv + 0.5;
          v = Math.max(0, Math.min(1, v * bv));
          var dist = Math.sqrt((xx + 0.5 - r0) * (xx + 0.5 - r0) + (yy + 0.5 - r0) * (yy + 0.5 - r0)), hl = Math.max(0, Math.min(1, r0 - dist + 0.5));
          var e = (ljosPlata ? 1 - v : v) * hl;
          p[i] = p[i + 1] = p[i + 2] = Math.round(255 * (1 - e)); p[i + 3] = 255;
        }
        yy++;
        if (yy < D && Date.now() >= til) return false;
      }
      x.putImageData(id, 0, 0);
      return true;
    } };
    if (verk) verk.push({ lyk: "", nyr: function () { return vinnsla; }, fylla: function () {}, el: null, villa: "mynd" });
    else vinnsla.skref(Infinity);
    hlutir.push({ gerd: "mynd", lag: "GRAFA-MYND", src: c, nafn: "ljosmynd", x: T((cx - ri) * k), y: T((cy - ri) * k), w: T(2 * ri * k), h: T(2 * ri * k) });
    gogn.mynd = { skra: st.photoName, sia: sia, stada: getComputedStyle(img).objectPosition, ljostGrafid: !ljosPlata };
  }
  // Gefur vafranum færi á að teikna og svara (scheduler.yield, annars MessageChannel, annars setTimeout),
  // og sér svo um að letrin séu komin og textarnir mældir (framUndirbua) áður en framSpec reiknar skrána
  function framBida() { return framGefa().then(function () { return framUndirbua(); }); }
  function framGefa() {
    return new Promise(function (r) {
      try { if (window.scheduler && typeof window.scheduler.yield === "function") { window.scheduler.yield().then(r, r); return; } } catch (e) {}
      if (window.MessageChannel) { var m = new MessageChannel(); m.port1.onmessage = function () { m.port1.onmessage = null; r(); }; m.port2.postMessage(0); return; }
      setTimeout(r, 0);
    });
  }
  // Rakning fyrir fram: eftir hverja breytingu (FRAM.bida ms kyrrð) eru táknin og nafnið rakin í aðgerðaleysi
  // (requestIdleCallback, mest FRAM.sneid ms í senn). Við körfuna er þá aðeins eftir að setja skrána saman.
  var framIdle = { kyn: 0, tim: 0, rk: null, lyk: "" };
  function framForrakna() {
    if (!window.SMFram) return;
    clearTimeout(framIdle.tim);
    framIdle.tim = setTimeout(framForraknaNu, FRAM.bida);
  }
  function framForraknaNu() {
    var kyn0 = framIdle.kyn;
    framUndirbua().then(function () { if (kyn0 === framIdle.kyn) framForraknaMaelt(); });
  }
  function framForraknaMaelt() {
    var verk = [], kyn = ++framIdle.kyn, i = 0;
    verk.forvinnsla = true;
    try { framSpec(0, false, verk); } catch (e) { return; }
    if (verk.bidur) { var im = verk.bidur; im.addEventListener("load", framForrakna, { once: true }); }
    verk = verk.filter(function (v) { return v.lyk && !framRakid[v.lyk]; });
    if (!verk.length) return;
    var ric = window.requestIdleCallback ? function (fn) { window.requestIdleCallback(fn, { timeout: 2000 }); } : function (fn) { setTimeout(fn, 40); };
    function lota(dl) {
      if (kyn !== framIdle.kyn) return;
      var t = dl && typeof dl.timeRemaining === "function" && !dl.didTimeout ? Math.min(FRAM.sneid, Math.max(1, dl.timeRemaining())) : FRAM.sneid, til = Date.now() + t;
      try {
        while (i < verk.length) {
          var v = verk[i];
          if (framRakid[v.lyk]) { i++; continue; }
          if (framIdle.lyk !== v.lyk || !framIdle.rk) { framIdle.lyk = v.lyk; framIdle.rk = v.nyr(); }
          if (!framIdle.rk.skref(til)) { ric(lota); return; }
          framGeyma(v.lyk, framIdle.rk.ut); framIdle.rk = null; framIdle.lyk = ""; i++;
          if (Date.now() >= til) { ric(lota); return; }
        }
      } catch (e) { framIdle.rk = null; framIdle.lyk = ""; }
    }
    ric(lota);
  }
  // Rekur verkin í sneiðum (mest FRAM.sneid ms í senn) og heldur áfram með það sem hófst fyrir fram
  function framVinna(verk, frest) {
    var i = 0, rk = null;
    return new Promise(function (res, rej) {
      (function lota() {
        var til = Math.min(Date.now() + FRAM.sneid, frest);
        try {
          while (i < verk.length) {
            var v = verk[i];
            if (v.lyk && framRakid[v.lyk]) { v.fylla(framRakid[v.lyk]); i++; rk = null; continue; }
            if (!rk) { if (v.lyk && framIdle.lyk === v.lyk && framIdle.rk) { rk = framIdle.rk; framIdle.rk = null; framIdle.lyk = ""; } else rk = v.nyr(); }
            if (!rk.skref(til)) break;
            framGeyma(v.lyk, rk.ut); v.fylla(rk.ut); rk = null; i++;
            if (Date.now() >= til) break;
          }
        } catch (e) { rej(e); return; }
        if (i >= verk.length) { res(); return; }
        if (Date.now() >= frest) { rej(new Error("timi")); return; }
        framGefa().then(lota);
      })();
    });
  }
  // Letrin og söfnin sótt um leið og viðskiptavinurinn byrjar
  var framHitad = false;
  function framHita() {
    if (framHitad || !window.SMFram) return;
    framHitad = true;
    try { framSkraTinos(); window.SMFram.forhlada(["fraunces-italic-300", "montserrat-400", TINOS]); } catch (e) {}
  }
  // ─── Kit glue (not from the old page) ──────────────────────────────────────
  // render() of the old page without its step markup: rules, plate, idle tracing; the kit is told (photo loaded).
  function render() { validate(); renderStage(); framForrakna(); if (vid && vid.breytt) vid.breytt(); }
  if (document.fonts && document.fonts.load) Promise.all([document.fonts.load('400 12.5px "Montserrat"'), document.fonts.load('400 26px Tinos', 'ÁÖÞ')]).then(renderStage, function () {});
  return {
    st: st, GOGN: GOGN, VARIANTS: VARIANTS, TOPS: TOPS, BOTTOMS: BOTTOMS, NO_TEXT: NO_TEXT, EFNI: EFNI, COLOR_NAME: COLOR_NAME,
    MONTHS: MONTHS, SAMPLE_NAME: SAMPLE_NAME, SAMPLE_DATES: SAMPLE_DATES, FRAM: FRAM, ASSET: ASSET, KR_LINA_MM: KR_LINA_MM,
    key: key, V: V, by: by, sizeObj: sizeObj, photoSide: photoSide, photoActive: photoActive, photoLeft: photoLeft,
    photoRight: photoRight, leftObj: leftObj, rightObj: rightObj, dateEmpty: dateEmpty, dateProblem: dateProblem,
    dateOk: dateOk, fmtDate: fmtDate, datesInOrder: datesInOrder, datesNone: datesNone, datesOptional: datesOptional, datesHidden: datesHidden, topText: topText, bottomText: bottomText,
    nameOk: nameOk, datesOk: datesOk, customOk: customOk, photoOk: photoOk, missingList: missingList, andJoin: andJoin,
    validate: validate, findShopifyVariant: findShopifyVariant, shopVariant: shopVariant, photoUpcharge: photoUpcharge,
    basePrice: basePrice, total: total, glyph: glyph, renderStage: renderStage, fitStage: fitStage, render: render,
    properties: properties, kr: kr, esc: esc, readPhoto: readPhoto, clearPhoto: clearPhoto,
    photoFile: function () { return photoFile; }, photoErr: function () { return photoErr; },
    framSpec: framSpec, framVinna: framVinna, framBida: framBida, framUndirbua: framUndirbua, framLikan: framLikan, _rakna: { Rakari: Rakari, gildi: framGildiTakn }, // _rakna: byggingarskrift táknaskrárinnar (sm-kr-takn.json)
    framIdle: framIdle, framForrakna: framForrakna, framHita: framHita,
    stortAl: stortAl, frjals: frjals, linurFrjals: linurFrjals, textaBreidd: textaBreidd
  };
  }
  window.SMKrossVel = { ny: ny };
})();
